export default {
    400: {
        title: "Slecht verzoek",
        header: "@:views.errors.400.title",
        html: "Ongeldig verzoek. Probeer het later opnieuw."
    },
    401: {
        title: "Er is een fout opgetreden tijdens het inloggen.",
        header: "@:views.errors.401.title",
        html: "Neem contact op met <a href='{email}' target='_blank'>de ondersteuning</a> ."
    },
    404: {
        title: "Pagina niet gevonden",
        header: "@:views.errors.404.title"
    },
    403: {
        title: "Toegang niet toegestaan",
        header: "Toegang niet toegestaan",

        contact: "O-I Peripheral is alleen beschikbaar voor medewerkers. Als u een medewerker bent en dit bericht ziet, neem dan contact op met uw lokale afdeling Personeel &amp; Cultuur om uw status bij te werken.",

        subject: "Uitrusting - Geschiktheid",

        html: "<p class='text-start'> @:views.errors.403.contact</p>",
        error: {
            disabled: {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>U komt momenteel niet in aanmerking. Neem contact op met <a href='#' role='button' data-widget-trigger='{widgetOptions}'>de ondersteuning</a> voor meer informatie.</p>"
            },
            "not-active": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>U komt momenteel niet in aanmerking. Neem voor meer informatie contact op met uw lokale afdeling Personeel &amp; Cultuur.</p>"
            },
            "not-allowed":{
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>O-I Peripheral is alleen beschikbaar voor medewerkers. Als u een medewerker bent en dit bericht ziet, neem dan contact op met uw lokale afdeling Personeel &amp; Cultuur om uw status bij te werken.</p>"
            },
            "no-manager": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Er staat geen actieve manager vermeld in uw ServiceNow-profiel. Neem contact op met uw lokale HR-medewerker om uw manager bij te werken.</p>"
            },
            "self-manager": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>In uw ServiceNow-profiel staat u als manager ingesteld. Neem contact op met uw lokale HR-medewerker om uw manager bij te werken.</p>"
            },
            "no-location": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Er staat geen locatie vermeld in uw ServiceNow-profiel. Neem contact op met uw lokale HR-medewerker om uw locatie bij te werken.</p>"
            },
            eligibility: {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>O-I Peripheral is alleen beschikbaar voor medewerkers. Als u een medewerker bent en dit bericht ziet, neem dan contact op met uw lokale afdeling Personeel &amp; Cultuur om uw status bij te werken.</p>",
            },
            "eligibility-location": {
                header: "",
                html: "Bedankt voor uw interesse in O-I Peripheral. Dit programma is momenteel niet beschikbaar in uw land.",
            },
            "secondary-account": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>U probeert momenteel toegang te krijgen tot O-I Peripheral via een secundair account. Probeer opnieuw in te loggen met uw primaire account.</p>"
            },
            "empty-core-id": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Uw ServiceNow-account heeft geen accountnaam. Neem contact op met uw lokale HR-medewerker om uw account bij te werken.</p>"
            },
            country: {
                header: "@:views.errors.403.header",
                html: " @:views.errors.403.contact",
            },
            "no-permissions": {
                header: "Geen toegang",
                subject: "Geen toegang",
                html: "Je hebt geen toestemming om deze pagina te openen.",
            },
            "virtual-denied": {
                header: "Je bent blijkbaar wat vroeg...",
                html: "<p class='text-start'>Bedankt voor uw interesse in O-I Peripheral. Het lijkt erop dat u de site hebt bezocht voordat u persoonlijk was geactiveerd en uitgenodigd. O-I Peripheral wordt gefaseerd uitgerold, land voor land en per gebruikersgroep. Zodra uw account is geactiveerd, ontvangt u een e-mail met een persoonlijke uitnodiging en instructies.</p><p class='text-start'> Klik op <a href='#' role='button' data-widget-trigger='{widgetOptions}'>Ondersteuning</a> voor vragen of problemen met uw bestelling of de website.</p>",
            }
        }
    },
    500: {
        title: "Onverwachte fout",
        header: "@:views.errors.500.title",
        message: "Er is een fout opgetreden. Probeer het later opnieuw."
    },
    code: {
        title: "Onverwachte fout",
        message: "@:views.errors.code.title",
        error: "Fout {code}."
    }
}